import { configureStore } from '@reduxjs/toolkit'

import { rootReducer } from './rootReducer';

export const store = (state) => {
  return configureStore({
    reducer: rootReducer,
  })
}